module.exports = __webpack_public_path__ + "img/platform-income-icon.ef922f8e.png";